import { parseStyleString, getAdvanced, getBackgroundImages } from '../utils';
import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbColumn } from '../../types/pbBlocks';

export type ColumnType = ContentTypeObject & PbColumn;

/**
 * Aggregates the configuration of a column element.
 * @param node
 */
export function columnConfigAggregator(node: CustomHtmlElement): ColumnType {
    const style = parseStyleString(node.attributes.style);

    return {
        ...getAdvanced(node, style),
        ...getBackgroundImages(node, style),
        minHeight: style?.minHeight ? style?.minHeight : undefined,
        uniqueID: node.attributes['data-pb-style'],
        verticalAlignment: style?.justifyContent,
        selfAlignment: style?.alignSelf,
        width: style?.width,
    };
}
